import Types from "./Types";

export const getOfficeHoursRequest = () => ({
  type: Types.GET_OFFICE_HOURS_REQUEST,
});

export const getOfficeHoursSuccess = (data) => ({
  type: Types.GET_OFFICE_HOURS_SUCCESS,
  payload: data,
});

export const getOfficeHoursFail = () => ({
  type: Types.GET_OFFICE_HOURS_FAIL,
});

export const officeHoursLoading = (isLoading) => ({
  type: Types.OFFICE_HOURS_LOADING,
  payload: isLoading,
});

export const createOfficeHourRequest = (body, onDone) => ({
  type: Types.CREATE_OFFICE_HOUR_REQUEST,
  payload: body,
  onDone,
});

export const createOfficeHourSuccess = (data) => ({
  type: Types.CREATE_OFFICE_HOUR_SUCCESS,
  payload: data,
});

export const createOfficeHourFail = () => ({
  type: Types.CREATE_OFFICE_HOUR_FAIL,
});

export const updateOfficeHourRequest = (payload, onDone) => ({
  type: Types.UPDATE_OFFICE_HOUR_REQUEST,
  payload,
  onDone,
});

export const updateOfficeHourSuccess = (data) => ({
  type: Types.UPDATE_OFFICE_HOUR_SUCCESS,
  payload: data,
});

export const updateOfficeHourFail = () => ({
  type: Types.UPDATE_OFFICE_HOUR_FAIL,
});

export const deleteOfficeHourRequest = (id) => ({
  type: Types.DELETE_OFFICE_HOUR_REQUEST,
  payload: id,
});

export const deleteOfficeHourSuccess = (id) => ({
  type: Types.DELETE_OFFICE_HOUR_SUCCESS,
  payload: id,
});

export const deleteOfficeHourFail = () => ({
  type: Types.DELETE_OFFICE_HOUR_FAIL,
});
